import andyHdLogo from "@/assets/andyhdlogo.png";
import styles from "./Footer.module.css";

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.brandSection}>
          <div className={styles.AndyLogo}>
            <img src={andyHdLogo} alt="Andy logo" className={styles.logoImg} />
            <span className={styles.brandName}>Andy App</span>
          </div>
          <p className={styles.brandTagline}>
            Helping Texans save on property taxes through automated protest services.
          </p>

          <div className={styles.socialRow}>
            <a
              href="https://www.facebook.com/TheAndyAppTx/photos/"
              target="_blank"
              rel="noreferrer"
            >
              <span className={styles.socialIcon}>f</span>
            </a>
            <a href="https://x.com/theandyapp_" target="_blank" rel="noreferrer">
              <span className={styles.socialIcon}>x</span>
            </a>
            <a href="https://www.instagram.com/theandyapp/reels/" target="_blank" rel="noreferrer">
              <span className={styles.socialIcon}>in</span>
            </a>
            <a
              href="https://www.linkedin.com/company/the-andy-app/?viewAsMember=true"
              target="_blank"
              rel="noreferrer"
            >
              <span className={styles.socialIcon}>li</span>
            </a>
          </div>
        </div>

        <div className={styles.linksSection}>
          <div className={styles.column}>
            <h4 className={styles.columnTitle}>About</h4>
            <a href="#how-it-works" className={styles.link}>
              How it works
            </a>
            <a href="#pricing" className={styles.link}>
              Pricing
            </a>
            <a href="#faq" className={styles.link}>
              FAQS
            </a>
          </div>

          <div className={styles.column}>
            <h4 className={styles.columnTitle}>Company</h4>
            <a href="#about" className={styles.link}>
              About Us
            </a>
            <a href="#affiliate" className={styles.link}>
              Join Our Affiliate Program
            </a>
            <a href="#refer" className={styles.link}>
              Refer A Friend
            </a>
          </div>

          <div className={styles.column}>
            <h4 className={styles.columnTitle}>Contact</h4>
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>Email</span>
              {/* <a href="mailto:marketing@theandyapp.com" className={styles.linkHighlight}> */}
              marketing@theandyapp.com
              {/* </a> */}
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>Phone</span>
              {/* <a href="tel:15129561160" className={styles.linkHighlight}> */}
              512-956-1160
              {/* </a> */}
              {/* <a href="tel:14697484860" className={styles.linkHighlight}> */}
              469-748-4860
              {/* </a> */}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <span className={styles.copy}>&copy; 2026 The Andy App. All rights reserved.</span>
        <div className={styles.bottomLinks}>
          <a href="#privacy" className={styles.bottomLink}>
            Privacy Policy
          </a>
          <a href="#terms" className={styles.bottomLink}>
            Terms &amp; Conditions
          </a>
        </div>
      </div>
    </footer>
  );
};
